export default __webpack_public_path__ + "static/media/SWT0370.34I-18854_-14910_0.5c61aba7.jpg";